/* ══════════════════════════════════════════════════════════════════════════
   TLH — wallet button running order   (/cart page AND the slide-out drawer)

   Both surfaces stack the accelerated checkout buttons

       CHECK OUT · PayPal · Shop Pay · G Pay

   but <shopify-accelerated-checkout-cart> prints them in the order Shopify's
   wallet-configs lists (Shop Pay first) and lays them out inside a CLOSED
   shadow root, one named <slot> per wallet. Because the boxes are built in
   that shadow tree, nothing in the light DOM reaches them: `order` on the
   host's children is computed but never used, and re-ordering the elements in
   the DOM is ignored as well — both were measured, both no-ops. Which slot an
   element is assigned to is the one lever left, and it is the mechanism the
   platform intends for exactly this.

   Deliberately conservative. It swaps the two elements' `slot` attributes only
   when both wallets are present AND both are still sitting in the stock slots
   named below; anything else — a wallet switched off in admin, Shopify
   renaming a slot, another script having already moved one — and the stack is
   left exactly as Shopify built it. That also makes the swap idempotent: once
   PayPal holds Shop Pay's slot the guard no longer matches. The buttons keep
   their own behaviour throughout; only the slot they paint into changes.

   Pairs with the wallet skins in assets/tlh-cart.css (the page) and
   assets/tlh-cart-drawer.css (the drawer), which restyle PayPal and G Pay to
   the export's flat blue / all-white pills. Loaded once from
   layout/theme.liquid, because the drawer exists on every page.
   ══════════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* The two surfaces that carry a skinned stack. Anything else on the site
     keeps Shopify's own order — this never runs storewide. */
  var ROOTS = '.tlh-cart, #site-cart-sidebar';

  /* The two wallets the export shows in the opposite order to Shopify's, and
     the stock slot each one ships in. Both names are checked before anything
     moves, so a rename upstream simply turns this file into a no-op. */
  var WANTED_FIRST = { tag: 'shopify-paypal-button', slot: 'button-PayPal' };
  var STOCK_FIRST = { tag: 'shop-pay-wallet-button', slot: 'button-ShopPay' };

  function reorder(host) {
    var paypal = host.querySelector(WANTED_FIRST.tag);
    var shopPay = host.querySelector(STOCK_FIRST.tag);
    if (!paypal || !shopPay) return;
    if (paypal.getAttribute('slot') !== WANTED_FIRST.slot) return;
    if (shopPay.getAttribute('slot') !== STOCK_FIRST.slot) return;

    paypal.setAttribute('slot', STOCK_FIRST.slot);
    shopPay.setAttribute('slot', WANTED_FIRST.slot);
  }

  function sweep() {
    var roots = document.querySelectorAll(ROOTS);
    for (var i = 0; i < roots.length; i++) {
      var hosts = roots[i].querySelectorAll('shopify-accelerated-checkout-cart');
      for (var j = 0; j < hosts.length; j++) reorder(hosts[j]);
    }
  }

  function start() {
    var roots = document.querySelectorAll(ROOTS);
    if (!roots.length) return;
    sweep();

    if (!window.MutationObserver) return;
    /* Both surfaces re-render their summary wholesale on every quantity change
       — the drawer also rebuilds itself on each add-to-cart — and the wallet
       elements upgrade asynchronously, so the sweep has to run again on both.
       The SDKs mutate their own subtrees heavily while booting, hence the
       frame-coalesced callback rather than one sweep per record. */
    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        sweep();
      });
    });
    for (var i = 0; i < roots.length; i++) {
      observer.observe(roots[i], { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
